import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  AuthenticationService,
  AccionEspecificaService,
  AgeticService,
  CategoriaProgService,
  FuenteService,
  FusService,
  GeneralService,
  IndicadorService,
  OperacionService,
  OrganismoService,
  PartidaPresService,
  PoaGestionService,
  PoaTechoService,
  ProgramaService,
  ReversionService,
  RiesgoService,
  TareaDetalleService,
  TareaService,
  TipoService,
  TraspasoService,
  UnidadMedidaService,
  UnidadOrgService,
  SolicitudModificacionService,
  IndicadorProgramacionService,
  UnidadEjecutoraSigepService,
  RevisionOperacionODSService,
  RevisionAcpODSService,
  OdsService,
  PsdiService,
  RolesService,
  VistaService,
  SeguimientoPdesService,
  SeguimientoPsdiService,
  SeguimientoPeiService,
  NotificacionService,
  SiapService,
  AccionCortoPlazoService,  
  
  
  

} from './service.index';
import { SolicitudPacService } from './formulacion/solicitud-pac.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    //NgxSoapModule
  ],
  providers: [
    AuthenticationService,
    AccionEspecificaService,
    AgeticService,
    CategoriaProgService,
    FuenteService,
    FusService,
    GeneralService,
    IndicadorService,
    OperacionService,
    OrganismoService,
    PartidaPresService,
    PoaGestionService,
    PoaTechoService,
    ProgramaService,
    ReversionService,
    RiesgoService,
    TareaDetalleService,
    TareaService,
    TipoService,
    TraspasoService,
    UnidadMedidaService,
    UnidadOrgService,
    SolicitudModificacionService,
    UnidadEjecutoraSigepService,
    RevisionOperacionODSService,
    RevisionAcpODSService,
    OdsService,
    PsdiService,
    RolesService,
    VistaService,
    SeguimientoPdesService,
    SeguimientoPsdiService,
    SeguimientoPeiService,
    NotificacionService,
    SolicitudPacService,
    SiapService,    
    AccionCortoPlazoService
    
  ],
  declarations: []
})
export class ServiceModule { }
